export class GlobalQueryParams {
    public static readonly impersonateAsPerson: string = 'impersonateAsPerson';
    public static readonly viewPersonId: string = 'viewPersonId';
}

